import { vysionTrack } from './vysionService';

const setOfferVysion = (param: any): void => {
  switch (param.event) {
    case 'VISIT CARD ACTIVITY':
      vysionTrack(param, 'dashboard-activityFeed-activityCard');
      break;
    case 'SHOW MORE ACTIVITY':
      vysionTrack(param, 'dashboard-activityFeed-showMore');
      break;
    case 'NAVBAR SEARCH':
      vysionTrack(param, 'dashboard-navBar-search');
      break;
    case 'NAVBAR INTERESTS':
      vysionTrack(param, 'dashboard-navBar-interests');
      break;
    case 'NAVBAR MESSAGES':
      vysionTrack(param, 'dashboard-navBar-messages');
      break;
    case 'NAVBAR OFFERS':
      vysionTrack(param, 'dashboard-navBar-offers');
      break;
    case 'NAVBAR FAVOURITES':
      vysionTrack(param, 'dashboard-navBar-favorites');
      break;
    case 'TOAST MESSAGE':
      vysionTrack(param, 'toast-messagedYou');
      break;
    case 'TOAST FAVOURITE':
      vysionTrack(param, 'toast-favoritedYou');
      break;
    case 'TOAST OFFER':
      vysionTrack(param, 'toast-offeredYou');
      break;
    case 'MAKE OFFER PROFILE':
      vysionTrack(param, 'profile-makeOffer');
      break;
    case 'CANCEL OFFER PROFILE':
      vysionTrack(param, 'profile-cancelOffer');
      break;
    case 'IGNORE OFFER PROFILE':
      vysionTrack(param, 'profile-ignoreOffer');
      break;
    case 'COUNTER OFFER PROFILE':
      vysionTrack(param, 'profile-counterOffer');
      break;
    case 'ACCEPT OFFER PROFILE':
      vysionTrack(param, 'profile-acceptOffer');
      break;
    case 'PROFILE PHOTO':
      vysionTrack(param, 'profile-profilePhoto');
      break;
    case 'OTHER PROFILE PHOTO':
      vysionTrack(param, 'profile-otherPhoto');
      break;
    case 'PRIVATE PHOTO':
      vysionTrack(param, 'profile-privatePhotoPlaceholder');
      break;
    case 'IGNORE OFFER':
      vysionTrack(param, 'offers-receivedOffers-ignoreOffer');
      break;
    case 'COUNTER OFFER':
      vysionTrack(param, 'offers-receivedOffers-counterOffer');
      break;
    case 'ACCEPT OFFER':
      vysionTrack(param, 'offers-receivedOffers-acceptOffer');
      break;
    case 'CANCEL OFFER':
      vysionTrack(param, 'offers-sentOffers-cancelOffer');
      break;
    case 'DISPLAY MODAL OFFER':
      vysionTrack(param, 'offerModal');
      break;
    case 'SEND OFFER':
      vysionTrack(param, 'offerModal-sendOffer');
      break;
    case 'REVISE OFFER':
      vysionTrack(param, 'offerModal-reviseOffer');
      break;
    case 'DECLINE OFFER':
      vysionTrack(param, 'offerModal-declineOffer');
      break;
    case 'SEND CANCEL':
      vysionTrack(param, 'offerModal-cancel');
      break;
    case 'SEND CLOSE':
      vysionTrack(param, 'offerModal-close');
      break;
    case 'SEND SUGGEST':
      vysionTrack(param, 'offerModal-suggest');
      break;
    case 'SEND AMOUNT CUSTOM':
      vysionTrack(param, 'offerModal-customAmount');
      break;
    case 'SEND AMOUNT 50':
      vysionTrack(param, 'offerModal-50');
      break;
    case 'SEND AMOUNT 75':
      vysionTrack(param, 'offerModal-75');
      break;
    case 'SEND AMOUNT 100':
      vysionTrack(param, 'offerModal-100');
      break;
    case 'SEND AMOUNT 150':
      vysionTrack(param, 'offerModal-150');
      break;
    case 'SEND AMOUNT 200':
      vysionTrack(param, 'offerModal-200');
      break;
    case 'UNLOCK MESSAGE':
      vysionTrack(param, 'offerModal-unlockMessage');
      break;
    default:
      return;
  }
};

export { setOfferVysion };
